import React, { useState, useEffect } from 'react';
import { checkIsInternal } from '@src/utility/createStorage';
import { CONTENT_EDITOR_DROPDOWN_CONSTANTS, CONTENT_EDITOR_MENU_ITEMS } from './constant';
import ContentEditorDropdown from './ContentEditorDropdown';

const { SESSION_KEYS, EVENTS, ROLES, NAV_DEFAULTS, POLLING } = CONTENT_EDITOR_DROPDOWN_CONSTANTS;

const checkIsInternalAdmin = (): boolean => {
  try {
    const currentUserStr = sessionStorage.getItem(SESSION_KEYS.CURRENT_USER);
    if (currentUserStr) {
      const currentUser = JSON.parse(currentUserStr);
      if (currentUser && currentUser[0]) {
        return currentUser[0].UserPersonas?.some(
          (item: { UserRole: string }) => item.UserRole === ROLES.UHCI_ADMIN
        );
      }
    }
    return false;
  } catch (e) {
    return false;
  }
};

const ContentEditorDropdownConnected: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isInternal, setIsInternal] = useState(false);
  const [isSimulation, setIsSimulation] = useState(
    sessionStorage.getItem(SESSION_KEYS.SIMULATION_MODE) === 'true'
  );

  useEffect(() => {
    const handleSimulationChange = () => {
      setIsSimulation(sessionStorage.getItem(SESSION_KEYS.SIMULATION_MODE) === 'true');
    };
    window.addEventListener(EVENTS.EXIT_PROVIDER_VIEW, handleSimulationChange);
    window.addEventListener(EVENTS.DROPDOWN_STATE_CHANGE, handleSimulationChange);
    return () => {
      window.removeEventListener(EVENTS.EXIT_PROVIDER_VIEW, handleSimulationChange);
      window.removeEventListener(EVENTS.DROPDOWN_STATE_CHANGE, handleSimulationChange);
    };
  }, []);

  useEffect(() => {
    setIsAdmin(checkIsInternalAdmin());
    setIsInternal(checkIsInternal());

    const intervalId = setInterval(() => {
      const admin = checkIsInternalAdmin();
      const internal = checkIsInternal();
      setIsAdmin(admin);
      setIsInternal(internal);
      if (admin && internal) {
        clearInterval(intervalId);
      }
    }, POLLING.INTERVAL_MS);

    const timeoutId = setTimeout(() => clearInterval(intervalId), POLLING.TIMEOUT_MS);

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, []);

  const navigateTo = (path: string) => {
    setOpen(false);
    sessionStorage.setItem(SESSION_KEYS.CANCEL_POPUP, 'false');
    window.dispatchEvent(new CustomEvent(EVENTS.DROPDOWN_STATE_CHANGE, { detail: { value: 1 } }));
    window.dispatchEvent(
      new CustomEvent(EVENTS.REACT_NAVIGATION, {
        detail: {
          url: path,
          index: NAV_DEFAULTS.INDEX,
          subIndex: NAV_DEFAULTS.SUB_INDEX,
          selectedRowIndex: NAV_DEFAULTS.SELECTED_ROW_INDEX,
          selectedSubIndex: NAV_DEFAULTS.SELECTED_SUB_INDEX,
        },
      })
    );
  };

  if (!isAdmin || !isInternal || isSimulation) return null;

  return (
    <ContentEditorDropdown
      open={open}
      menuItems={CONTENT_EDITOR_MENU_ITEMS}
      onToggle={() => setOpen((prev) => !prev)}
      onClose={() => setOpen(false)}
      onNavigate={navigateTo}
    />
  );
};

export default ContentEditorDropdownConnected;
